import {Activities, CollarLogEvents, CurrentMaxId, GPSPositions, Mortalities, MortalityImplants, Proximities, Separations, TrapEvents, VaginalImplants, VirtualFenceEvents, Events} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public Activities: Activities,
    public CollarLogEvents: CollarLogEvents,
    public CurrentMaxId: CurrentMaxId,
    public GPSPositions: GPSPositions,
    public Mortalities: Mortalities,
    public MortalityImplants: MortalityImplants,
    public Proximities: Proximities,
    public Separations: Separations,
    public TrapEvents: TrapEvents,
    public VaginalImplants: VaginalImplants,
    public VirtualFenceEvents: VirtualFenceEvents,
    public Events: Events,
  ) {}
}